import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import YoungImg from "./assets/images/Young_Back.jpg";
import TestimonialSlider from "./components/TestimonialSlider";
import FounderImg from "./assets/images/CZARPROFILE.jpeg";
import html2pdf from "html2pdf.js";
import countries from "./constant/countries";
import CountryDropdown from "./CountryDropdown";
import ServicesSection from "./components/pinkhelp/ServicesSection";
import FaqSection from "./components/pinkhelp/FaqSection";
import bgImage from "./assets/images/business.jpg";
import bgImage1 from "./assets/images/family.jpg";

const Home = () => {
  const [formData, setFormData] = useState({ name: "", email: "" });

  const paperRef = useRef();

  const handleDownload = () => {
    const element = paperRef.current;

    // Temporarily show it for PDF rendering
    element.style.display = "block";

    html2pdf()
      .set({
        margin: 0,
        filename: "Tariff_Stock_Exchange_Whitepaper.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      })
      .from(element)
      .save()
      .then(() => {
        // Hide again after rendering
        element.style.display = "none";
      });
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.email) {
      toast.success("🎉 Thank you! You’ve joined the ecosystem.", {
        position: "top-center",
        autoClose: 3000,
      });
      setFormData({ name: "", email: "" });
    } else {
      toast.error("❗ Please fill out both fields.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <section className="relative bg-[url('./assets/images/Hero_Back.jpg')] bg-cover bg-center bg-no-repeat min-h-screen flex items-center justify-center text-main-light">
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 to-gray-900/20 z-0"></div>

        {/* Content Container */}
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center lg:text-left flex flex-col justify-center items-center lg:items-start">
          <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl mt-24 font-extrabold uppercase font-barlow leading-tight sm:leading-snug animate-slide-in">
            Connecting Women to Trusted Help — in Every Country.
          </h1>

          <p className="mt-4 text-lg sm:text-xl md:text-2xl lg:text-4xl font-aeonik leading-relaxed animate-fade-in max-w-4xl">
            The World’s First Women-Focused Global Platform
          </p>

          <p className="mt-3 text-sm sm:text-base md:text-lg lg:text-2xl font-aeonik leading-relaxed animate-fade-in max-w-3xl">
            Find health, legal, business, and personal support — from local
            experts in 200+ countries.
          </p>

          <p className="mt-2 text-sm sm:text-base md:text-lg lg:text-xl font-aeonik leading-relaxed animate-fade-in max-w-2xl text-main-light/80">
            Currently live in 60+ countries — expanding globally every week.
          </p>

          {/* CTA Buttons */}
          <div className="mt-8 sm:mt-12 flex flex-col sm:flex-row items-center gap-4">
            <Link to="/advertising-portal">
              <button
                onClick={() => {
                  document
                    .getElementById("partner-section")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
                className="bg-white text-main-dark px-6 py-3 sm:px-8 sm:py-4 rounded-lg text-base sm:text-lg font-bold shadow-lg hover:bg-main-green hover:text-white transition-all duration-300"
              >
                Become a Partner or Advertiser
              </button>
            </Link>
          </div>
        </div>
      </section>
      <div className="w-full overflow-hidden bg-black py-4">
  <div className="flex whitespace-nowrap animate-marquee gap-10">
    {/* Repeat the countries twice for seamless loop */}
    {[...countries, ...countries].map((country, index) => (
      <div
        key={index}
        className="flex items-center gap-2 text-white text-sm sm:text-base px-4"
      >
        <img src={country.flag} alt={country.name} className="w-6 h-4 object-cover" />
        <span>{country.name}</span>
      </div>
    ))}
  </div>
</div>
      <section className="bg-main-light py-20 px-6 sm:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-4 animate-slide-in">
            How Pink Help Works
          </h2>
          <p className="text-lg sm:text-xl font-aeonik text-text-color max-w-3xl mx-auto mb-12 animate-fade-in">
            A simple, powerful way to connect women with trusted service
            providers — in every corner of the world.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 text-left">
            {/* Step 1 */}
            <div className="p-6 bg-white rounded-xl shadow hover:shadow-md transition animate-fade-in">
              <h3 className="text-xl font-bold text-main-dark mb-2">
                1. Choose Your Country
              </h3>
              <p className="text-text-color font-aeonik">
                Start with your local Pink Page portal.
              </p>
            </div>

            {/* Step 2 */}
            <div className="p-6 bg-white rounded-xl shadow hover:shadow-md transition animate-fade-in">
              <h3 className="text-xl font-bold text-main-dark mb-2">
                2. Browse Service Categories
              </h3>
              <p className="text-text-color font-aeonik">
                10 areas, fully focused on women.
              </p>
            </div>

            {/* Step 3 */}
            <div className="p-6 bg-white rounded-xl shadow hover:shadow-md transition animate-fade-in">
              <h3 className="text-xl font-bold text-main-dark mb-2">
                3. Connect with Verified Providers
              </h3>
              <p className="text-text-color font-aeonik">
                Listings, profiles, and contact details.
              </p>
            </div>

            {/* Step 4 */}
            <div className="p-6 bg-white rounded-xl shadow hover:shadow-md transition animate-fade-in">
              <h3 className="text-xl font-bold text-main-dark mb-2">
                4. Access Premium Support (Optional)
              </h3>
              <p className="text-text-color font-aeonik">
                Exclusive listings for high-end needs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <section
        className="bg-main-light py-16 px-6 sm:px-12 lg:px-16"
        id="what-we-are-building"
      >
        <div className="text-center">
          <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-6 animate-slide-in">
            What We’re Building
          </h2>
          <p className="text-xl font-aeonik text-text-color mb-12 animate-fade-in">
            A New Financial Ecosystem Designed Around Global Tariff Power
          </p>
          <p className="text-base sm:text-lg font-aeonik text-text-color max-w-4xl mx-auto mb-12 animate-fade-in">
            The Tariff Stock Exchange isn’t a platform. It’s a new financial
            order—built for those who understand that in today’s world, policy
            is profit and trade disruptions are opportunities.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-screen-xl mx-auto">
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 1. Tariff-Based Assets
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              New instruments and digital vehicles engineered to reflect tariff
              pressure points across countries, sectors, and supply chains. We
              create value from both winners and losers of trade wars.
            </p>
          </div>
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 2. Tariff Chip© & Tariff Processor©
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              Proprietary AI-powered trade intelligence hardware that processes,
              encrypts, and accelerates real-time tariff data for high-level
              decision-making.
            </p>
          </div>
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in-delay cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 3. Tariff Coin©
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              A native digital token used for access, staking, forecasting, and
              profit-sharing from tariff-based opportunities. A monetization
              mechanism for trade conflict.
            </p>
          </div>
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 4. Policy Prediction Markets
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              Predict tariff decisions, supply chain shifts, or trade deals—get
              rewarded for accurate geopolitical foresight. Turn intelligence
              into returns.
            </p>
          </div>
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 5. Country and Sector Dashboards
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              Dynamic dashboards showing tariff impact, risk exposure, and
              opportunity flows across 250+ countries and key industries. A
              command center for modern trade.
            </p>
          </div>
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in-delay cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 6. A Global Network of Builders
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              A syndicate of exporters, investors, and strategists who don’t
              wait for policy—they engineer systems around it. We see tariff
              disruption as an investment class.
            </p>
          </div>
        </div>
        <div className="text-center mt-16 max-w-4xl mx-auto animate-fade-in">
          <p className="text-xl font-aeonik text-text-color">
            This is more than Fintech. This is trade intelligence weaponized.
            Welcome to the ecosystem that profits where others panic.
          </p>
        </div>
      </section> */}

      <ServicesSection />



      <section
  id="advertisers"
  className="relative py-20 px-6 sm:px-12 lg:px-20 bg-cover bg-center bg-no-repeat"
  style={{ backgroundImage: `url(${bgImage1})` }}
>
  {/* Overlay */}
  <div className="absolute inset-0 bg-white bg-opacity-80 backdrop-blur-sm"></div>

  {/* Content */}
  <div className="relative max-w-6xl mx-auto text-center">
    <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-4 animate-slide-in">
      Own a Business <br />
      One Company. One Woman. One Nation.
    </h2>
    <p className="text-lg sm:text-xl font-aeonik text-text-color max-w-3xl mx-auto mb-12 animate-fade-in">
      <strong>Women of the World Holdings, Inc.</strong>
    </p>

    <div className="bg-white rounded-xl p-6 shadow hover:shadow-md transition max-w-4xl mx-auto mb-12">
      <h3 className="text-xl font-bold mb-4 text-main-dark">The Vision</h3>
      <p className="text-text-color font-aeonik">
        To empower women in every country through ownership, structure,
        training and platform-led change.
        <br />
        From Women of Afghanistan to Women of Zimbabwe, we have established 197
        national companies + 50 territories — each one uniquely positioned to
        serve, represent, and uplift women within its borders.
      </p>
    </div>

    <div className="flex justify-center">
      <Link to="/own-a-busniess">
        <button className="bg-main-green text-white px-6 py-3 rounded-lg font-bold hover:bg-green-700 transition">
          🌍 Read More
        </button>
      </Link>
    </div>
  </div>
</section>

      

      <div className="w-full px-4 py-12 bg-gradient-to-br from-white via-gray-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          {/* Country Dropdown */}

          {/* Hero Heading */}
          <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
            Helping Women in Every Country
          </h1>

          {/* Tagline */}
          <p className="text-lg md:text-xl text-gray-700 mb-6">
            Pink Help is active in 200+ countries and territories, each with its
            own dedicated portal — connecting women to localized services and
            trusted professionals.
          </p>

          {/* Subheading */}
          <p className="text-base md:text-lg text-gray-600 mb-10 max-w-3xl mx-auto">
            Each country operates its own version of the World’s First
            Women-Focused Global Platform — powered by Pink Help.
          </p>

          {/* Cards Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-pink-100 p-6 rounded-2xl shadow-2xl hover:scale-105 transition-transform">
              <h3 className="text-xl font-semibold mb-2 text-pink-700">
                Empower Women Locally
              </h3>
              <p className="text-gray-700">
                Every Pink Help country portal connects women to verified
                health, legal, business, and personal support — tailored to
                local needs.
              </p>
            </div>

            <div className="bg-pink-100 p-6 rounded-2xl shadow-2xl hover:scale-105 transition-transform">
              <h3 className="text-xl font-semibold mb-2 text-pink-700">
                Build Visibility, Create Impact
              </h3>
              <p className="text-gray-700">
                Service providers, consultants, and clinics gain trusted
                visibility by helping women find real solutions — online and on
                the ground.
              </p>
            </div>

            <div className="bg-pink-100 p-6 rounded-2xl shadow-2xl hover:scale-105 transition-transform">
              <h3 className="text-xl font-semibold mb-2 text-pink-700">
                Local Pages, Global Reach
              </h3>
              <p className="text-gray-700">
                Each country gets its own dedicated Pink Help platform — uniting
                200+ territories under one powerful women-focused network.
              </p>
            </div>
          </div>

        </div>
      </div>

      <section
        id="advertisers"
        className="relative py-20 px-6 sm:px-12 lg:px-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-white bg-opacity-80 backdrop-blur-sm"></div>

        {/* Content */}
        <div className="relative max-w-6xl mx-auto text-center">
          <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-4 animate-slide-in">
            Promote Your Business on the World’s First Women-Focused Global
            Platform
          </h2>
          <p className="text-lg sm:text-xl font-aeonik text-text-color max-w-3xl mx-auto mb-12 animate-fade-in">
            Reach women across your country with premium visibility in health,
            legal, education, business, and more.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 text-left max-w-4xl mx-auto mb-12">
            <div className="bg-white rounded-xl p-6 shadow hover:shadow-md transition">
              <h3 className="text-xl font-bold mb-2 text-main-dark">
                1. Standard Listing
              </h3>
              <p className="text-text-color font-aeonik">
                Fixed-size, professional profile to list your services and
                contact details.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow hover:shadow-md transition">
              <h3 className="text-xl font-bold mb-2 text-main-dark">
                2. Premium Spotlight
              </h3>
              <p className="text-text-color font-aeonik">
                Top placement, double ad size, homepage presence, and social
                media push for maximum visibility.
              </p>
            </div>
          </div>

          <p className="text-sm text-text-color max-w-2xl mx-auto mb-8">
            🚨 <strong>Exclusive Model:</strong> One Premium Partner per
            Category, per Country — available on application only.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/advertising-portal">
              <button
                className="bg-main-green text-white px-6 py-3 rounded-lg font-bold hover:bg-green-700 transition"
                onClick={() => {
                  document
                    .getElementById("partner-section")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                📢 Apply to Advertise
              </button>
            </Link>
          </div>
        </div>
      </section>

      <FaqSection />

      <section class="bg-gradient-to-r from-main-light via-white to-main-light py-12 px-6 text-text-color font-barlow mt-8">
        <div class="max-w-5xl mx-auto shadow-2xl rounded-xl overflow-hidden bg-white relative">
          <div class="absolute inset-0 bg-gradient-to-b from-transparent to-main-light opacity-30 pointer-events-none"></div>
          <div class="p-10">
            <h2 class="text-4xl font-extrabold text-main-dark animate-fade-in text-center mb-4">
              <span class="underline decoration-main-green decoration-4">
                Live Chat & 24/7 Support
              </span>
            </h2>
            <p class="text-lg text-center text-gray-700 animate-slide-in paragraph_mobile">
              Our Live Chat 24/7 Support is here to assist you at every step of
              your journey. Whether you have questions about our program price
              plans, need guidance through the admissions process, or want to
              learn more about how IPC can help you achieve your career goals,
              our team is always ready to help.
            </p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 p-4 lg:p-10 animate-fade-in-delay">
            <div class="flex items-center gap-4">
              <div class="bg-main-green text-main-dark w-12 h-12 flex justify-center items-center rounded-full shadow-md animate-bounce">
                <i class="fas fa-clock text-xl"></i>
              </div>
              <p class="text-lg font-medium paragraph_mobile">
                24/7 Availability: Our team is here to assist you any time, day
                or night.
              </p>
            </div>

            <div class="flex items-center gap-4">
              <div class="bg-main-green text-main-dark w-12 h-12 flex justify-center items-center rounded-full shadow-md animate-bounce">
                <i class="fas fa-user text-xl"></i>
              </div>
              <p class="text-lg font-medium paragraph_mobile">
                Dedicated Experts: Personalized support tailored to meet your
                needs.
              </p>
            </div>

            <div class="flex items-center gap-4">
              <div class="bg-main-green text-main-dark w-12 h-12 flex justify-center items-center rounded-full shadow-md animate-bounce">
                <i class="fas fa-comments text-xl"></i>
              </div>
              <p class="text-lg font-medium paragraph_mobile">
                Clear Communication: Get detailed guidance on admissions, plans,
                and more.
              </p>
            </div>

            <div class="flex items-center gap-4">
              <div class="bg-main-green text-main-dark w-12 h-12 flex justify-center items-center rounded-full shadow-md animate-bounce">
                <i class="fas fa-handshake text-xl"></i>
              </div>
              <p class="text-lg font-medium paragraph_mobile">
                Trusted Support: Depend on us for seamless assistance and peace
                of mind.
              </p>
            </div>
          </div>

          <div class="flex justify-center mt-6 pb-10">
            <a
              href="https://wa.me/923219700700" // Replace with your actual WhatsApp number
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="bg-gradient-to-r from-main-green to-green-500 text-white px-8 py-4 rounded-full font-extrabold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 text-lg">
                Start a Conversation
              </button>
            </a>
          </div>
        </div>
      </section>

      <TestimonialSlider />

      <div
        id="whitepaper"
        ref={paperRef}
        style={{
          display: "none",
          fontFamily: "Segoe UI, sans-serif",
          color: "#333",
          maxWidth: "900px",
          margin: "auto",
          padding: "40px",
          backgroundColor: "#f9f9ff",
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "32px",
            fontWeight: "800",
            color: "#1d3557",
            marginBottom: "10px",
          }}
        >
          Whitepaper: Tariff Stock Exchange (TSE)
        </h1>
        <h2
          style={{
            textAlign: "center",
            fontSize: "18px",
            color: "#457b9d",
            marginBottom: "30px",
          }}
        >
          Transforming Tariffs into the Backbone of a New Financial Ecosystem
        </h2>

        {/* Section: Executive Summary */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          Executive Summary
        </h3>
        <p>
          The global economy is being redefined—not by innovation or natural
          evolution, but by the resurgence of tariffs, trade conflicts, and
          economic nationalism. In an era where every policy shift can cause a
          ripple across borders, <strong>Tariff Stock Exchange (TSE)</strong>
          introduces a bold vision: to convert disruption into infrastructure,
          policy into profit, and fear into foresight.
        </p>
        <p>
          TSE is not a tracking tool or a traditional marketplace—it is a new
          class of economic engine built around the strategic monetization of
          tariffs. With the integration of <strong>Tariff Coin</strong>,
          <strong>Tariff Chips</strong>, <strong>Prediction Markets</strong>,
          and a <strong>Global Economic Intelligence Network</strong>, the TSE
          ecosystem enables governments, investors, and industries to thrive
          amid chaos.
        </p>

        {/* Section: Problem Statement */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          1. Problem Statement
        </h3>
        <p>
          Tariffs are no longer just fiscal tools—they have become the modern
          weapons of economic warfare. They influence the price of goods,
          reroute supply chains, create inflationary pressures, and disrupt
          geopolitical stability. Despite their massive impact, there exists no
          dedicated system to navigate, capitalize on, or strategically resolve
          tariff-based disruptions.
        </p>
        <p>
          While environmental crises gain attention, trade conflicts often go
          unrecognized as an existential economic threat. However, for many
          developing nations, tariff warfare can trigger recessions, fuel
          unemployment, and destabilize currencies.
        </p>

        {/* Section: Vision */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          2. The Vision
        </h3>
        <p>
          Tariff Stock Exchange emerges with a revolutionary objective: to
          establish a fully integrated financial ecosystem built around
          tariff-driven dynamics. Rather than reacting to trade wars, we
          architect instruments that can convert every policy into an
          opportunity.
        </p>
        <p>
          We believe that by creating this infrastructure, nations and
          individuals can not only protect themselves from tariff fallout—but
          use the system to grow, profit, and stabilize their economies.
        </p>

        {/* Section: Ecosystem */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          3. Components of the Ecosystem
        </h3>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
          <li>
            <strong>Tariff Coin (TFC):</strong> A utility token designed to
            unlock access to data, trade predictions, analytics, and influence
            over the ecosystem’s governance.
          </li>
          <li>
            <strong>Tariff-Based Assets:</strong> Sectoral, bilateral, and
            regional instruments that reflect tariff pressure and economic
            opportunity in real-time.
          </li>
          <li>
            <strong>Tariff Chip & Tariff Microprocessor:</strong> Hardware
            systems for sovereign and institutional deployment, capable of
            analyzing, encrypting, and simulating tariff impacts at scale.
          </li>
          <li>
            <strong>Policy Prediction Markets:</strong> Crowdsourced forecasting
            systems allowing experts, analysts, and citizens to predict trade
            outcomes, policy changes, and disruptions—with financial rewards for
            accuracy.
          </li>
          <li>
            <strong>Global Intelligence Dashboards:</strong> A data interface
            for countries, companies, and trade blocs—offering insight into
            risk, opportunity, and policy response.
          </li>
        </ul>

        {/* Section: Benefits */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          4. Strategic Benefits
        </h3>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
          <li>
            <strong>Economic Sovereignty:</strong> Countries gain tools to make
            data decisions, rather than reacting to foreign tariffs blindly.
          </li>
          <li>
            <strong>Investor Advantage:</strong> New classes of trade-based,
            tariff-indexed assets allow investors to gain exposure to
            geopolitical volatility.
          </li>
          <li>
            <strong>Manufacturing Insight:</strong> Companies can forecast cost
            swings and proactively shift sourcing, production, and distribution.
          </li>
          <li>
            <strong>Diplomatic Leverage:</strong> Governments can simulate
            policy decisions and deploy countermeasures strategically, not
            emotionally.
          </li>
        </ul>

        {/* Section: Bigger Picture */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          5. The Bigger Picture
        </h3>
        <p>
          Our belief is simple:
          <strong style={{ color: "#1d3557" }}>
            if we can quantify disruption, we can profit from it—and ultimately,
            we can resolve it.
          </strong>
        </p>
        <p>
          TSE doesn't glorify economic conflict. It exists to give all
          stakeholders—especially those from vulnerable economies—the power to
          act with clarity, to trade with knowledge, and to govern with
          foresight. When properly understood, tariffs can become a
          <strong>mechanism of global balance</strong>, not just chaos.
        </p>
        <p>
          In many ways,
          <strong>
            tariff-based instability is a bigger long-term threat than
            environmental collapse
          </strong>
          , because it erodes the foundations of trade, cooperation, and mutual
          growth. But unlike climate change, this challenge can be resolved
          today—by building the right systems.
        </p>

        {/* Section: Conclusion */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          6. Conclusion
        </h3>
        <p>
          The Tariff Stock Exchange is not an alternative financial
          experiment—it is a new baseline. A foundation for those who choose to
          see the next crisis not with fear, but with tools.
        </p>
        <p>
          This is not just a platform. It is the
          <strong>infrastructure for the post-globalization world</strong>.
        </p>

        {/* Footer */}
        <div
          style={{
            marginTop: "40px",
            textAlign: "center",
            fontSize: "16px",
            color: "#555",
          }}
        >
          <p>
            <strong>Website:</strong>
            <a
              href="https://tariffstockexchange.com"
              style={{ color: "#1d3557" }}
            >
              TariffStockExchange.com
            </a>
          </p>
          <p>
            <strong>Status:</strong> Launching Q2 2025
          </p>
          <p>
            <strong>Contact:</strong>
            <a
              href="mailto:info@TariffStockExchange.com"
              style={{ color: "#1d3557" }}
            >
              info@TariffStockExchange.com
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Home;
